export default __webpack_public_path__ + "static/media/organizationLogo.7f75d2d8.png";